<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <!-- <Sidebar></Sidebar> -->

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" v-if="data.detalhes">

                    <div class="hidden-xs">    
                        <center>
                            <img src="static/config/logo.png" class="logo-inicio">
                        </center>
                    </div>      


                    <div class="hidden-xs row margin-bottom-50">
                        <div class="col-xl-12">
                            <button class="button small gray" type="button" v-on:click="$root.back()">
                                <i class="las la-arrow-left"></i> Voltar
                            </button>
                        </div>
                    </div>

                    <div class="solicitar-permissao" v-if="!data.detalhes.permissao">
                        <div class="row">
                            <div class="col-xs-12 col-xl-4 col-xl-offset-5">
                                <h3>
                                    <i class="material-icons">block</i>
                                    Você não possui permissão para visualizar os dados do paciente.
                                </h3>
                                <h4>Deseja solicitar ao paciente o acesso aos dados?</h4>
                                <button type="button" class="button green" v-on:click="solicitarUsoDados()">
                                    <i class="las la-lock"></i>
                                    Solicitar acesso
                                </button>
                                <div class="clearfix"></div>
                                <button type="button" class="button color-white" v-on:click="get(true)">
                                    <i class="las la-sync-alt"></i>
                                    Atualizar
                                </button>                                

                                <small class="block">
                                    O paciente receberá uma SMS / WhatsApp pedindo a autorização para visualização das informações.
                                </small>
                            </div>
                        </div>
                    </div>

                    <!-- Row -->
                    <div class="row" v-bind:class="{'sem-permissao': !data.detalhes.permissao}">

                        <div class="col-lg-8 col-md-7 col-xs-12 col-xl-5 " v-if="config.prontuario">
                            <div class="tabs tabs-default margin-top-0 margin-bottom-25">
                                <div class="tabs-header">
                                    <ul style="width: 100%;">
                                        <li v-if="config.prontuario.dados" class="menu-prontuario" v-bind:class="{'active': tab == 'informacoes'}">
                                            <a v-on:click="setTab('informacoes')">
                                                <i class="las la-info-circle"></i>
                                                Dados
                                            </a>
                                        </li>
                                        <li v-if="config.prontuario.avaliacoes" class="menu-prontuario" v-bind:class="{'active': tab == 'avaliacoes'}">
                                            <a v-on:click="setTab('avaliacoes')">
                                                <i class="las la-file-medical-alt"></i>
                                                Avaliações
                                            </a>
                                        </li>                       
                                        <li v-if="config.prontuario.evolucoes" class="menu-prontuario" v-bind:class="{'active': tab == 'evolucoes'}">
                                            <a v-on:click="setTab('evolucoes')">
                                                <i class="las la-comment"></i>
                                                Evoluções
                                            </a>
                                        </li>
                                        <li v-if="config.prontuario.exames" class="menu-prontuario" v-bind:class="{'active': tab == 'exames'}">
                                            <a v-on:click="setTab('exames')">
                                                <i class="las la-file-alt"></i>
                                                Exames
                                            </a>
                                        </li>                                        
                                        <li v-if="config.prontuario.ged" class="menu-prontuario" v-bind:class="{'active': tab == 'documentos'}">
                                            <a v-on:click="setTab('documentos')" style="line-height: 120%">
                                                <i class="las la-file"></i>
                                                Histórico anterior a 29/07/2022
                                            </a>
                                        </li>                                        
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-12 margin-bottom-10" v-if="data.detalhes">
                            <h4>{{data.detalhes.PESSOA_FISICA.NM_PESSOA_FISICA}}</h4>
                        </div>
                        <div class="col-xl-12" v-show="tab == 'informacoes'">

                            <nav id="navigation" v-if="data.detalhes" class="menu-dropdown">
                                <ul id="responsive" style="display: inline-block !important">
                                    <li>
                                        <a class="button small color-secondary">
                                            <i class="las la-bars"></i>
                                            Opções
                                        </a>
                                        <ul class="dropdown-nav">
                                            <li>
                                                <router-link v-if="$root.user.tipo == 'profissional'" :to="{'name': 'GerenciarReceitas', 'query': {'CD_PESSOA_FISICA': data.detalhes.PESSOA_FISICA.CD_PESSOA_FISICA}}">
                                                    Emitir receita
                                                </router-link>
                                            </li>
                                            <li>
                                                <router-link :to="{'name': 'Receitas', 'query': {'CD_PESSOA_FISICA': data.detalhes.PESSOA_FISICA.CD_PESSOA_FISICA}}">
                                                    Visualizar receitas
                                                </router-link>
                                            </li>
                                            <li>
                                                <router-link :to="{'name': 'Receitas', 'query': {'CD_PESSOA_FISICA': data.detalhes.PESSOA_FISICA.CD_PESSOA_FISICA, 't': 'atestados'}}">
                                                    Visualizar atestados
                                                </router-link>
                                            </li>                                            
                                        </ul>
                                    </li>
                                </ul>
                            </nav>                         

                            <h5 class="block-title">
                                <i class="las la-info-circle"></i>                
                                Informações
                            </h5>                            
                            <div class="table-scroll" style="overflow-x: scroll;" v-if="data.detalhes">

                                <table class="table table-bordered table-bordered-default table-force-responsive table-responsive margin-bottom-0">
                                    <tbody>   
                                        <tr>
                                            <td data-label="">
                                                Dados do paciente
                                            </td>
                                            <td data-label="Código" class="td-50 td-50-l">
                                                {{data.detalhes.PESSOA_FISICA ? data.detalhes.PESSOA_FISICA.CD_PESSOA_FISICA || '-' : '-'}}
                                            </td>                 
                                            <td data-label="Atendimento" class="td-50">
                                                {{data.detalhes.ATENDIMENTOS_V ? data.detalhes.ATENDIMENTOS_V.NR_ATENDIMENTO || '-' : '-'}}
                                            </td>
                                            <td data-label="Prontuário" class="td-50 td-50-l">
                                                {{data.detalhes.PESSOA_FISICA ? data.detalhes.PESSOA_FISICA.NR_PRONTUARIO || '-' : '-'}}
                                            </td>    
                                            <td data-label="Sexo" class="td-50">
                                                {{data.detalhes.ATENDIMENTO_PACIENTE_V ? data.detalhes.ATENDIMENTO_PACIENTE_V.DS_SEXO || '-' : '-'}}
                                            </td>
                                            <td data-label="Nascimento" class="td-50 td-50-l" v-if="data.detalhes.PESSOA_FISICA ? data.detalhes.PESSOA_FISICA.DT_NASCIMENTO : false">
                                                {{data.detalhes.PESSOA_FISICA.DT_NASCIMENTO | formatDate}}
                                            </td>
                                            <td data-label="Nascimento" class="td-50 td-50-l" v-if="data.detalhes.PESSOA_FISICA ? !data.detalhes.PESSOA_FISICA.DT_NASCIMENTO : true">
                                                -
                                            </td>                                            
                                            <td data-label="Idade" class="td-50">
                                                {{data.detalhes.ATENDIMENTO_PACIENTE_V ? data.detalhes.ATENDIMENTO_PACIENTE_V.DS_IDADE || '-' : '-'}}
                                            </td>
                                            <td data-label="CPF" class="td-50 td-50-l">
                                                {{data.detalhes.PESSOA_FISICA ? data.detalhes.PESSOA_FISICA.NR_CPF || '-' : '-'}}
                                            </td>
                                            <td data-label="RG" class="td-50">
                                                {{data.detalhes.PESSOA_FISICA ? data.detalhes.PESSOA_FISICA.NR_IDENTIDADE || '-' : '-'}}
                                            </td>                                     
                                            <td data-label="Convênio" v-if="data.detalhes.ATENDIMENTOS_V ? data.detalhes.ATENDIMENTOS_V.DS_CONVENIO : false">
                                                {{data.detalhes.ATENDIMENTOS_V ? data.detalhes.ATENDIMENTOS_V.DS_CONVENIO || '-' : '-'}} / Cód: {{data.detalhes.ATENDIMENTOS_V ? data.detalhes.ATENDIMENTOS_V.NR_DOC_CONVENIO || '-' : '-'}} 
                                            </td> 
                                            <td data-label="Convênio" v-if="data.detalhes.ATENDIMENTOS_V ? data.detalhes.ATENDIMENTOS_V.DS_CONVENIO : true">
                                                -
                                            </td>                                             
                                            <td data-label="Plano">
                                                {{data.detalhes.ATENDIMENTO_PACIENTE_V ? data.detalhes.ATENDIMENTO_PACIENTE_V.DS_PLANO || '-' : '-'}}
                                            </td>   
                                            <td data-label="Responsável">
                                                {{data.detalhes.COMPL_PESSOA_FISICA_GER_V ? data.detalhes.COMPL_PESSOA_FISICA_GER_V.NM_CONTATO || '-' : '-'}}
                                            </td>                                                                                              
                                            <td data-label="Telefone" v-if="data.detalhes.COMPL_PESSOA_FISICA_GER_V ? data.detalhes.COMPL_PESSOA_FISICA_GER_V.NR_DDI_TELEFONE : false">
                                                + {{data.detalhes.COMPL_PESSOA_FISICA_GER_V ? data.detalhes.COMPL_PESSOA_FISICA_GER_V.NR_DDI_TELEFONE || '-' : '-'}} ({{data.detalhes.COMPL_PESSOA_FISICA_GER_V ? data.detalhes.COMPL_PESSOA_FISICA_GER_V.NR_DDD_TELEFONE || '-' : '-'}}) {{data.detalhes.COMPL_PESSOA_FISICA_GER_V ? data.detalhes.COMPL_PESSOA_FISICA_GER_V.NR_TELEFONE || '-' : '-'}}
                                            </td>   
                                            <td data-label="Telefone" v-if="data.detalhes.COMPL_PESSOA_FISICA_GER_V ? data.detalhes.COMPL_PESSOA_FISICA_GER_V.NR_DDI_TELEFONE : true">
                                                -
                                            </td>                                                                                                                                 
                                            <td data-label="E-mail">
                                                {{data.detalhes.COMPL_PESSOA_FISICA_GER_V ? data.detalhes.COMPL_PESSOA_FISICA_GER_V.DS_EMAIL || '-' : '-'}}
                                            </td> 
                                            <td data-label="Endereço">
                                                {{data.detalhes.COMPL_PESSOA_FISICA_GER_V ? data.detalhes.COMPL_PESSOA_FISICA_GER_V.DS_END || '-' : '-'}}
                                            </td>
                                            <td data-label="Cidade/Estado">
                                                {{data.detalhes.COMPL_PESSOA_FISICA_GER_V ? data.detalhes.COMPL_PESSOA_FISICA_GER_V.DS_CID_EST || '-' : '-'}}
                                            </td>                                            
                                            <td style="padding: 0.03px;"></td>
                                        </tr>
                                        
                                    </tbody>
                                </table>  

                                <div class="submit-field" v-if="data.detalhes">
                                    <div class="checkbox disabled margin-bottom-10">
                                        <input type="checkbox" class="" disabled="" readonly="" id="receber-notificacoes" :checked="data.detalhes.PESSOA_FISICA.IE_PERM_SMS_EMAIL == 'S'">
                                        <label for="receber-notificacoes"><span class="checkbox-icon"></span> Permissão para recebimento de notificações por e-mail e SMS.</label>
                                    </div>
                                </div>                                   

                                <table class="table table-bordered table-force-responsive table-bordered-default table-responsive margin-bottom-0">
                                    <tbody>   
                                        <tr>
                                            <td data-label="">
                                                Médico assistente
                                            </td>
                                            <td data-label="Nome do médico">
                                                {{data.detalhes.ATENDIMENTOS_V ? data.detalhes.ATENDIMENTOS_V.NM_MEDICO || '-' : '-'}}
                                            </td>                 
                                            <td data-label="CRM" class="td-50 td-50-l">
                                                {{data.detalhes.ATENDIMENTO_PACIENTE_V ? data.detalhes.ATENDIMENTO_PACIENTE_V.NR_CRM || '-' : '-'}}
                                            </td>             
                                            <td data-label="Especialidade" class="td-50">
                                                {{data.detalhes.TWS_ESPECIALIDADE_MEDICA_V ? data.detalhes.TWS_ESPECIALIDADE_MEDICA_V.DS_ESPECIALIDADE || '-' : '-'}}

                                            </td>
                                            <td style="padding: 0.03px;"></td>
                                        </tr>
                                        
                                    </tbody>
                                </table>        

                                <div class="dashboard-box margin-top-0 cards">
                                    <div class="content margin-bottom-10" v-if="data.detalhes.PRESCR_MEDICA_V">
                                        <h5 class="block-title">
                                            <i class="las la-list"></i>
                                            Medicações
                                        </h5>

                                        <h5 v-if="data.detalhes.PRESCR_MEDICA_V.length == 0" class="margin-bottom-0 empty">
                                            <i class="las la-times"></i>                                          
                                            Nenhum resultado encontrado.
                                        </h5>
                                        <ul class="dashboard-box-list" v-if="data.detalhes.PRESCR_MEDICA_V">
                                            <li v-for="(item, index) in data.detalhes.PRESCR_MEDICA_V">
                                                <a class="job-listing card2">
                                                    <div class="job-listing-details">
                                                        <div class="job-listing-description" style="padding-top: 0px;">
                                                            <div class="row">
                                                                <div class="col-lg-12">

                                                                    <h4 style="text-align: right; float: right;">#{{item.NR_PRESCRICAO}}</h4>
                                                                    <p class="margin-bottom-5 margin-top-0">
                                                                        Informações:
                                                                    </p>                                                                        
                                                                    <div style="line-height: 20px; color: #555;">
                                                                        <small class="dark" v-if="item.PACIENTE_SETOR">
                                                                            <i class="las la-chevron-circle-right"></i>
                                                                            <b>Protocolo:</b> {{item.PACIENTE_SETOR.NM_PROTOCOLO}} 
                                                                            <span class="dashboard-status-button green" v-if="item.PACIENTE_SETOR.IE_STATUS == 'A'">Ativo</span>
                                                                            <span class="dashboard-status-button color-gray" v-if="item.PACIENTE_SETOR.IE_STATUS == 'I'">Inativo</span>
                                                                            <span class="dashboard-status-button red" v-if="item.PACIENTE_SETOR.IE_STATUS == 'F'">Finalizado</span>
                                                                            <br>
                                                                        </small>
                                                                        <small class="dark" v-if="item.PACIENTE_SETOR">
                                                                            <i class="las la-chevron-circle-right"></i>
                                                                            <b>Início do protocolo:</b> {{item.PACIENTE_SETOR.DT_INICIO_TRAT | formatDateTime}}
                                                                            <br>
                                                                        </small>
                                                                        <small class="dark" v-if="item.PACIENTE_SETOR ? item.PACIENTE_SETOR.DT_FINAL_TRAT : false">
                                                                            <i class="las la-chevron-circle-right"></i>
                                                                            <b>Final do protocolo:</b> {{item.PACIENTE_SETOR.DT_FINAL_TRAT | formatDateTime}}
                                                                            <br>
                                                                        </small>                                                                                      
                                                                        <small class="dark">
                                                                            <i class="las la-chevron-circle-right"></i>
                                                                            <b>Número prescrição:</b> {{item.NR_PRESCRICAO}}
                                                                            <br>
                                                                        </small>                      
                                                                        <small class="dark">
                                                                            <i class="las la-chevron-circle-right"></i>
                                                                            <b>Número atendimento:</b> {{item.NR_ATENDIMENTO}}
                                                                            <br>
                                                                        </small>
                                                                        <small class="dark">
                                                                            <i class="las la-chevron-circle-right"></i>
                                                                            <b>Setor atendimento:</b> {{item.DS_SETOR_ATENDIMENTO}}
                                                                            <br>
                                                                        </small>
                                                                        <small v-if="item.DS_IMPRESSAO">
                                                                            <i class="las la-chevron-circle-right"></i>
                                                                            <b>Tipo:</b> {{item.DS_IMPRESSAO}}
                                                                            <br>
                                                                        </small>
                                                                        <small class="dark">
                                                                            <i class="las la-user"></i>
                                                                            <b>Usuário:</b> {{item.NM_USUARIO.toUpperCase()}}
                                                                            <br>                                                                
                                                                        </small>
                                                                        <small class="dark">
                                                                            <i class="las la-clock"></i>
                                                                            <b>Criado em:</b> {{item.DT_PRESCRICAO_ORIGINAL | formatDateTime}}h
                                                                            <br>
                                                                        </small>                      
                                                                    </div>                                                                 
                                                                    <p class="margin-bottom-0">
                                                                        Itens:
                                                                    </p>
                                                                    <div v-for="item2 in item.PRESCR_MATERIAL" class="margin-top-5 margin-bottom-10" style="font-size: 12px; color: #555;">
                                                                        
                                                                        <b>⦿ Nome:</b> {{item2.DS_REDUZIDA}} <span class="dashboard-status-button red" v-if="item2.IE_SUSPENSO == 'S'" style="font-size: 12px;">Suspenso</span><br>
                                                                        <b>⦿ Intervalo:</b> {{item2.CD_INTERVALO}}<br>
                                                                        <b>⦿ Horários:</b> {{item2.DS_HORARIOS_MEDICO || item2.DS_HORARIOS}}<br>
                                                                        <b>⦿ Aplicação:</b> {{item2.IE_VIA_APLICACAO}}<br>
                                                                        <span v-if="item2.QT_DOSE"><b>⦿ Dose:</b> {{item2.QT_DOSE}} {{item2.CD_UNIDADE_MEDIDA}}<br></span>
                                                                        <span v-if="item2.DT_INICIO_MEDIC"><b>⦿ Início medicação:</b> {{item2.DT_INICIO_MEDIC | formatDate}}<br></span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div> 

                                <div v-if="data.detalhes.usuario">
                                    <h5 class="block-title">
                                        <i class="las la-cog"></i>
                                        Ativar/desativar
                                    </h5>  
                                  
                                    <div class="submit-field">
                                        <div class="checkbox">
                                            <input type="checkbox" id="enviar-sintomas" true-value="1" false-value="0" @click="changeSintomas" v-model="data.detalhes.usuario.enviarSintomas">
                                            <label for="enviar-sintomas"><span class="checkbox-icon"></span> Acompanhamento de sintomas diário ativado (quimioterapia).</label>
                                        </div>
                                    </div>

                                    <router-link :to="{'name': 'Sintomas', 'query': {'c': data.detalhes.usuario.cod}}" class=" button button-gray small block-mobile gray">
                                        Histórico de sintomas
                                    </router-link>

                                </div>  
                            </div>  
                        </div> 

                        <div class="col-xl-12" v-show="tab == 'avaliacoes'">
                            <div class="dashboard-box margin-top-0 cards avaliacoes">
                                <div class="content" v-if="data.avaliacoes">
                                    <h5 class="block-title ">
                                        <i class="las la-list"></i>
                                        Avaliações realizadas <b>{{data.avaliacoes.EVOLUCAO_PACIENTE_LIB_V.length > 0 ? "(" + data.avaliacoes.EVOLUCAO_PACIENTE_LIB_V.length + ")" : ''}}</b>
                                    </h5>
                                    <h5 v-if="data.avaliacoes.EVOLUCAO_PACIENTE_LIB_V.length == 0" class="empty">
                                        <i class="las la-times"></i>                                          
                                        Nenhum resultado encontrado.
                                    </h5>
                                    <ul class="dashboard-box-list" v-if="data.avaliacoes.EVOLUCAO_PACIENTE_LIB_V">
                                        <li v-for="(item, index) in data.avaliacoes.EVOLUCAO_PACIENTE_LIB_V" style="padding: 0px; ">
                                            <a class="job-listing card2">
                                                <div class="job-listing-details">
                                                    <div class="job-listing-description" style="padding-top: 0px;">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <div style="line-height: 110%; padding-top: 0px; margin-top: 0px;" class="margin-bottom-5 v-html" v-html="item.DS_EVOLUCAO">
                                                                </div>
                                                                <div style="line-height: 20px;">
                                                                    <small v-if="item.DS_IMPRESSAO">
                                                                        <i class="las la-comment"></i>
                                                                        Impressão: {{item.DS_IMPRESSAO}}
                                                                        <br>
                                                                    </small>
                                                                    <small>
                                                                        <i class="las la-user"></i>
                                                                        {{item.NM_USUARIO.toUpperCase()}}
                                                                    </small>
                                                                    <br>                                                                
                                                                    <small>
                                                                        <i class="las la-clock"></i>
                                                                        {{item.DT_ATUALIZACAO | formatDateTime}}
                                                                    </small>                      
                                                                </div>                                                                 
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div> 
                        </div> 

                        <div class="col-xl-12" v-show="tab == 'evolucoes'">
                            <div class="row">
                                <div class="col-xl-12" v-if="data.detalhes && $root.user.tipo == 'profissional' && config.prontuario.criarEvolucoes && $root.user.permissoes.includes('criar-evolucoes')">
                                    <form method="post" v-if="data.detalhes.ATENDIMENTO_PACIENTE_V" style="width: 100%;" class="margin-bottom-0 margin-top-15" v-on:submit.prevent="submit('evolucoes')">
                                        <div class="row">
                                            <div class="col-lg-7 col-xs-12 col-xl-6 col-md-10">
                                                <div class="submit-field" style="margin-bottom: 0px">
                                                    <h5>Adicionar nota clínica:</h5>
                                                    <textarea class="with-border margin-bottom-0" style="min-height: 30px; padding: 10px; line-height: 120%;" rows="5" v-model="form.evolucoes.texto" placeholder="Escreva aqui..."></textarea>
                                                </div>
                                            </div>

                                            <div class="col-xs-7 col-xl-12 col-lg-12 padding-top-12">
                                            </div>

                                            <div class="col-lg-3 col-md-2 col-xs-5 hidden-xs hidden-md">
                                                <div class="submit-field">
                                                    <button class="button small color-secondary" type="submit">
                                                        <i class="las la-plus"></i>
                                                        Adicionar
                                                    </button>                                          
                                                </div>
                                            </div>

                                            <div class="col-lg-3 col-md-2 col-xs-5 hidden-lg hidden-xl" style="text-align: right;">
                                                <div class="submit-field">
                                                    <div class="hidden-xl hidden-lg hidden-sm margin-top-10"></div>
                                                    <div class="hidden-xs clearfix" style="margin-top: 32px;"></div>
                                                    <button class="button small color-secondary block-mobile" type="submit">
                                                        <i class="las la-plus"></i>
                                                        Adicionar
                                                    </button>                                          
                                                </div>
                                            </div>
                                        </div>
                                    </form>                           
                                </div>

                                <div class="col-lg-12">                        
                                    <div class="dashboard-box margin-top-0 cards">
                                        <div class="content" v-if="data.evolucoes">
                                            <h5 class="block-title ">
                                                <i class="las la-list"></i>
                                                Últimas evoluções
                                            </h5>
                                            <h5 v-if="data.evolucoes.EVOLUCAO_PACIENTE_LIB_V.length == 0" class="empty">
                                                <i class="las la-times"></i>                                          
                                                Nenhum resultado encontrado.
                                            </h5>
                                            <ul class="dashboard-box-list" v-if="data.evolucoes.EVOLUCAO_PACIENTE_LIB_V" style="display: block;">
                                                <li v-for="(item, index) in data.evolucoes.EVOLUCAO_PACIENTE_LIB_V" style="padding: 0px;">
                                                    <a class="job-listing card2">
                                                        <div class="job-listing-details">
                                                            <div class="job-listing-description" style="padding-top: 0px;">
                                                                <div class="row">
                                                                    <div class="col-lg-12">
                                                                        <div style="line-height: 20px;">
                                                                            <small v-if="item.DS_IMPRESSAO">
                                                                                <i class="las la-comment"></i>
                                                                                Impressão: {{item.DS_IMPRESSAO}}
                                                                                <br>
                                                                            </small>
                                                                            <small class="dark">
                                                                                <i class="las la-chevron-circle-right"></i>
                                                                                <b>Número atendimento:</b> {{item.NR_ATENDIMENTO}}
                                                                                <br>
                                                                            </small>
                                                                            <small class="dark">
                                                                                <i class="las la-user"></i>
                                                                                <b>Usuário:</b> {{item.NM_USUARIO.toUpperCase()}}
                                                                                <br>                                                                
                                                                            </small>                                                               
                                                                            <small class="dark">
                                                                                <i class="las la-clock"></i>
                                                                                <b>Criado em:</b> {{item.DT_ATUALIZACAO | formatDateTime}}
                                                                            </small>                      
                                                                        </div>  
                                                                        <div style="line-height: 110%; padding: 10px; margin-top: 10px; border: 1px solid #efefef;" class="margin-bottom-5 v-html" v-html="item.DS_EVOLUCAO">
                                                                        </div>                                                                                                                                       
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>                               
                                </div> 
                            </div>                        
                        </div>                        

                        <div class="col-xl-12" v-show="tab == 'exames'">
                            <div class="dashboard-box margin-top-0 cards exames">
                                <div class="content" v-if="data.exames">

                                    <form method="get" style="width: 100%;" novalidate="" class="margin-bottom-0" v-on:submit.prevent="getTab('exames')">
                                        <div class="row">
                                            <div class="col-lg-3 col-xs-6 col-xl-2 col-md-5">
                                                <div class="submit-field margin-bottom-10">
                                                    <h5>De:</h5>
                                                    <input type="date" data-placeholder="___ /____ /_____" required="" class="with-border margin-bottom-0" v-model="form.exames.dataInicio">
                                                </div>
                                            </div>        
                                            <div class="col-lg-3 col-xs-6 col-xl-2 col-md-5">
                                                <div class="submit-field margin-bottom-10">
                                                    <h5>Até:</h5>
                                                    <input type="date" data-placeholder="___ /____ /_____" required="" class="with-border margin-bottom-0" v-model="form.exames.dataFinal">
                                                </div>
                                            </div>    
                                            <div class="col-lg-2 col-xs-6 col-xl-2 col-md-2" style="padding-right: 0px;">
                                                <div class="submit-field" v-if="data.exames.grupos">
                                                    <h5>Grupo:</h5>
                                                    <select class="with-border" v-model="form.exames.grupo">
                                                        <option value="">Todos</option>
                                                        <option v-for="(item, index) in data.exames.grupos" :key="item.cod" :value="item">{{item}}</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="col-lg-3 col-md-2 col-xs-4 hidden-xs hidden-md" style="">
                                                <div class="submit-field">
                                                    <div class="clearfix" style="margin-top: 21px;"></div>
                                                    <button type="submit" class="button green small" style="height: 40px">
                                                        <i class="las la-search"></i>
                                                        Filtrar
                                                    </button>                                          
                                                </div>
                                            </div>                                    

                                            <div class="col-lg-3 col-md-4 col-xs-5 hidden-lg hidden-xl" style="text-align: right;">
                                                <div class="submit-field">
                                                    <div class="hidden-xl hidden-lg hidden-sm hidden-md" style="margin-top: 22px;"></div>
                                                    <div class="hidden-xs clearfix hidden-xl hidden-md" style="margin-top: 32px;"></div>
                                                    <button type="submit" class="button green small block-mobile" style="height: 40px">
                                                        <i class="las la-search"></i>
                                                        Filtrar
                                                    </button>                                          
                                                </div>
                                            </div>
                                        </div>
                                        <div class="hidden-sm hidden-xl margin-top-20"></div>
                                    </form> 

                                    <div class="row">
                                        <div class="col-xs-12 col-xl-12">
                                            <h5 class="block-title ">
                                                <i class="las la-list"></i>
                                                <b>Lista de requisição de exames</b>
                                                <small v-if="data.exames.CLINIC_PEDIDO_EXAME.length > 0" style="display: block; font-size: 12px; margin-top: 0px; margin-bottom: 15px; color: #555; line-height: 130%;">Toque na requisição abaixo para visualizar todos os exames.</small>
                                            </h5>

                                            <h5 v-if="data.exames.CLINIC_PEDIDO_EXAME.length == 0" class="empty">
                                                <i class="las la-times"></i>                                          
                                                Nenhum resultado encontrado.
                                            </h5>
                                            <!-- <ul class="dashboard-box-list lg-scroll" v-if="data.exames.CLINIC_PEDIDO_EXAME.length > 0"> -->
                                            <ul class="dashboard-box-list" v-if="data.exames.CLINIC_PEDIDO_EXAME.length > 0">
                                                <li v-for="(item, index) in data.exames.CLINIC_PEDIDO_EXAME" class="click" style="padding: 0px; " v-bind:class="{'disabled': item.selecionado}">
                                                    <a class="job-listing card2">
                                                        <div class="job-listing-details" style="padding-top: 0px !important" v-on:click="openPrescricao(item)">
                                                            <div class="job-listing-description" style="padding-top: 12px;">
                                                                <div class="row">
                                                                    <div class="col-lg-12 col-xl-12 col-xs-12">

                                                                        <!-- <span class="dashboard-status-button color-gray margin-top-5">Prescrição nº {{item.NR_PRESCRICAO}}</span> -->
                                                                        <span class="dashboard-status-button color-primary margin-top-5 margin-bottom-5" style="font-weight: bold" v-if="item.GRUPO">{{item.GRUPO}}</span>
                                                                        <span class="block margin-top-5 margin-bottom-5">
                                                                            {{item.DS_EXAMES}}
                                                                        </span>
                                                                        <span class="block" style="color: #999">
                                                                            <i class="las la-user"></i> Médico solicitante: <b style="color: #666; font-weight: 600">{{item.NM_MEDICO}}</b>
                                                                        </span> 
                                                                        <span class="block" style="color: #999">
                                                                            <i class="las la-file"></i> Prescrição: <b style="color: #666; font-weight: 600">{{item.NR_PRESCRICAO}}</b>
                                                                        </span>                                                                         
                                                                        <span class="block" style="color: #999">
                                                                            <i class="las la-clock"></i> Data/hora: <b style="color: #666; font-weight: 600">{{item.DT_PRESCRICAO | formatDateTime}}</b>
                                                                        </span>                                                    
                                                                    </div>
                                                                    <div class="col-lg-12 col-xl-4 col-xs-12">

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>     
                                        <div class="col-xs-12 col-xl-6 scroll-to" style="padding-left: 20px;" v-if="data.prescricao">
                                            <h5 class="block-title ">
                                                <i class="las la-list-alt"></i>
                                                Lista de exames <b>{{data.prescricao.CLINIC_EXAMES_PEDIDO.length > 0 ? "(" + data.prescricao.CLINIC_EXAMES_PEDIDO.length + ")" : ''}}</b>
                                                
                                                <small v-if="data.prescricao.CLINIC_EXAMES_PEDIDO.length > 0" style="display: block; font-size: 12px; margin-top: 0px; margin-bottom: 15px; color: #555; line-height: 130%;">Toque no exame desejado para visualizar mais detalhes.</small>
                                            </h5>

                                            <div class="row margin-bottom-15" v-if="data.prescricao.CLINIC_EXAMES_PEDIDO.length > 0">
                                                <div class="col-xs-12">
                                                    <button type="button" v-on:click="selecionarTodosExames()" class="button gray small" style="font-size: 12px">
                                                        <i v-if="!selecionarTodosExamesAtivo" class="las la-check-square"></i>
                                                        <i v-if="selecionarTodosExamesAtivo" class="las la-minus-square"></i>
                                                        Selecionar todos
                                                    </button>
                                                    <button type="button" v-on:click="exportarExames()" class="button gray small" style="font-size: 12px">
                                                        <i class="las la-download"></i>
                                                        Salvar selecionados
                                                    </button>                                            
                                                </div>
                                            </div>

                                            <h5 v-if="data.prescricao.CLINIC_EXAMES_PEDIDO.length == 0" class="empty">
                                                <i class="las la-times"></i>                                          
                                                Nenhum resultado encontrado.
                                            </h5>
                                            <!-- <ul class="dashboard-box-list lg-scroll" v-if="data.prescricao.CLINIC_EXAMES_PEDIDO.length > 0"> -->
                                            <ul class="dashboard-box-list" v-if="data.prescricao.CLINIC_EXAMES_PEDIDO.length > 0">
                                                <li v-for="(item, index) in data.prescricao.CLINIC_EXAMES_PEDIDO" style="padding: 0px; " class="click">
                                                    <a class="job-listing card2">
                                                        <div class="checkbox margin-top-15">
                                                            <input type="checkbox" :id="'item-exame-' + item.NR_SEQ_INTERNO" true-value="true" false-value="false" v-model="item.selecionado" >
                                                            <label :for="'item-exame-' + item.NR_SEQ_INTERNO" class="margin-bottom-0" style="padding-left: 26px; "><span class="checkbox-icon"></span> 
                                                                #{{item.NR_SEQ_INTERNO}}
                                                        
                                                                <span class="dashboard-status-button color-primary margin-top-0 float-right" style="font-size: 12px" v-if="item.GRUPO">{{item.GRUPO}}</span>

                                                            </label>
                                                        </div>
                                                        <div class="job-listing-details" style="padding-top: 0px !important" v-on:click="openExame(item)">
                                                            <div class="job-listing-description" style="padding-top: 0px;">
                                                                <div class="row">
                                                                    <div class="col-lg-12">


                                                                        <span class="dashboard-status-button color-white margin-top-5">{{item.NM_EXAME}}</span>
                                                                        <br>
                                                                        <span style="font-size: 12px; color: #555;">
                                                                            <!-- <i class="las la-clock"></i> Data/hora: <b style="color: #666">{{item.DT_PRESCRICAO | formatDateTime}}</b> -->


                                                                            <span v-if="item.DS_LIBERADO != 'Liberado'" class="dashboard-status-button color-orange" style="padding: 2px 6px; line-height: 16px; margin-top: 5px;  font-size: 14px; font-weight: bold; display: block; text-align: center; ;">
                                                                                {{item.DS_LIBERADO}}
                                                                            </span>

                                                                            <span v-if="item.DS_LIBERADO == 'Liberado'" v-on:click.stop.prevent="exportarExame(item)" class="dashboard-status-button color-green block-mobile" style="padding: 2px 6px; line-height: 16px; margin-top: 5px;  font-size: 14px; font-weight: bold; display: block; text-align: center; ">
                                                                                <i class="las la-download"></i>
                                                                                Laudo
                                                                            </span>                                                       
                                                                        </span>                                                 
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>                                     
                                        <div class="col-xs-12 col-xl-6" style="padding-left: 20px; min-height: 100vh;" v-if="data.prescricao">
                                           
                                            <h5 class="block-title ">
                                                <i class="las la-file-alt"></i>
                                                Visualização
                                                <span v-if="data.prescricao.CLINIC_EXAMES_PEDIDO[0]">
                                                    <button type="button" v-if="data.prescricao.CLINIC_EXAMES_PEDIDO[0].DS_END_PACS" v-on:click.stop.prevent="visualizarPacs(data.prescricao.CLINIC_EXAMES_PEDIDO[0])" class="button color-orange small float-right" style="">
                                                        <i style="color: #fff; top: 0px;" class="las la-eye"></i>
                                                        Imagens do exame
                                                    </button>            
                                                </span>
                                            </h5>

                                            <small v-if="data.prescricao.CLINIC_EXAMES_PEDIDO.length > 0" style="display: block; font-size: 12px; margin-top: 0px; margin-bottom: 15px; color: #555; line-height: 130%;">Consulte abaixo a visualização completa da requisição de exames.</small>
                                            <div class="loading-preview-prescricao">                                                
                                                <div class="loadingio-spinner-rolling-afwndezwb5v">
                                                    <div class="ldio-cxcz2rj5xqh">
                                                        <div></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <iframe class="preview-prescricao" style="width: 100%; height: 100vh; border: none; display: none;"></iframe>
                                        </div>                                                                                
                                    </div>
                                </div>
                            </div> 
                        </div> 

                        <div class="col-xl-12" v-show="tab == 'documentos'">

                            <div class="row" >
                                <div class="col-lg-12">
                                    <h5 class="block-title">
                                        <i class="las la-list"></i>
                                        Documentos disponíveis <b v-if="data.documentos">({{data.documentos.itens.length}})</b>
                                    </h5>
                                </div>

                                <div class="col-xs-12 col-xl-12">

                                    <form method="get" style="width: 100%;" novalidate="" class="margin-bottom-0" v-on:submit.prevent="getTab('documentos')">
                                        <div class="row">
                                            <div class="col-lg-3 col-xs-6 col-xl-2 col-md-5">
                                                <div class="submit-field margin-bottom-10">
                                                    <h5>De:</h5>
                                                    <input type="date" data-placeholder="___ /____ /_____" required="" class="with-border margin-bottom-0" v-model="form.documentos.dataInicio">
                                                </div>
                                            </div>        
                                            <div class="col-lg-3 col-xs-6 col-xl-2 col-md-5">
                                                <div class="submit-field margin-bottom-10">
                                                    <h5>Até:</h5>
                                                    <input type="date" data-placeholder="___ /____ /_____" required="" class="with-border margin-bottom-0" v-model="form.documentos.dataFinal">
                                                </div>
                                            </div>    
                                            <div class="col-lg-2 col-xs-6 col-xl-2 col-md-2" style="padding-right: 0px;">
                                                <div class="submit-field" v-if="data.documentos">
                                                    <h5>Área:</h5>
                                                    <select class="with-border" v-model="form.documentos.area">
                                                        <option value="">Todas</option>
                                                        <option v-for="(item, index) in data.documentos.areas" v-if="data.documentos" :key="item.id" :value="item.id">{{item.nome}}</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="col-lg-3 col-md-2 col-xs-4 hidden-xs hidden-md" style="">
                                                <div class="submit-field">
                                                    <div class="clearfix" style="margin-top: 21px;"></div>
                                                    <button type="submit" class="button green small" style="height: 40px">
                                                        <i class="las la-search"></i>
                                                        Filtrar
                                                    </button>                                          
                                                </div>
                                            </div>                                    

                                            <div class="col-lg-3 col-md-4 col-xs-5 hidden-lg hidden-xl" style="text-align: right;">
                                                <div class="submit-field">
                                                    <div class="hidden-xl hidden-lg hidden-sm hidden-md" style="margin-top: 22px;"></div>
                                                    <div class="hidden-xs clearfix hidden-xl hidden-md" style="margin-top: 32px;"></div>
                                                    <button type="submit" class="button green small block-mobile" style="height: 40px">
                                                        <i class="las la-search"></i>
                                                        Filtrar
                                                    </button>                                          
                                                </div>
                                            </div>
                                        </div>
                                        <div class="hidden-sm hidden-xl margin-top-20"></div>
                                    </form> 
                                    <div v-if="data.documentos" class="">
                                        <div class="row margin-bottom-25" v-if="data.documentos.itens.length > 0">
                                            <div class="col-xs-12">
                                                <button type="button" v-on:click="selecionarTodosDocumentos()" class="button gray small" style="font-size: 12px">
                                                    <i v-if="!selecionarTodosDocumentosAtivo" class="las la-check-square"></i>
                                                    <i v-if="selecionarTodosDocumentosAtivo" class="las la-minus-square"></i>
                                                    Selecionar todos
                                                </button>
                                                <button type="button" v-on:click="exportarDocumentos()" class="button gray small" style="font-size: 12px">
                                                    <i class="las la-download"></i>
                                                    Salvar selecionados
                                                </button>                                            
                                            </div>
                                        </div>                                    
                                    </div>                                    
                                </div> 

                                <div class="col-lg-12" v-if="data.documentos">
                                    <h5 v-if="data.documentos.itens.length == 0" class="empty">
                                        <i class="las la-times"></i>                                          
                                        Nenhum resultado encontrado.
                                    </h5>
                                </div>
                                <div class="col-lg-12" v-if="data.documentos">
                                    <div class="attachments-container">
                                        <div class="attachment-box" v-for="(item, index) in data.documentos.itens">
                                            <span>
                                                <div class="checkbox">
                                                    <input type="checkbox" :id="'item-documento-' + item.id" true-value="true" false-value="false" v-model="item.selecionado" >
                                                    <label :for="'item-documento-' + item.id" style="padding-left: 26px"><span class="checkbox-icon"></span> {{item.endereco}}</label>
                                                </div>                                                
                                                <a v-on:click="openPDF($root.config.url + '/viewer/web/viewer.php?_cod=' + $root.user.cod + '&_token=' + $root.user.token + '&idDocumento=' + item.id, item)" style="cursor: pointer;">
                                                    <br>
                                                    <div class="dashboard-status-button color-secondary" style="font-size: 12px !important">
                                                        {{item.listaIndice[4].valor}}
                                                    </div>
                                                </a>
                                            </span>                                               
                                            <i style="width: 100%;">
                                                {{item.listaIndice[9].valor}}
                                                <button type="button" class="button color-green small float-right exportar-pdf" v-on:click.stop.prevent="exportarPDF($root.config.url + '/viewer/web/viewer.php?_cod=' + $root.user.cod + '&_token=' + $root.user.token + '&idDocumento=' + item.id + '&download=1', item)" style="font-size: 14px; font-weight: bold;">
                                                    <span class="las la-download" style="position: relative; top: 0px; margin-bottom: 0px !important; line-height: 12px !important;"></span>
                                                    Salvar
                                                </button>                                             
                                            </i>

                                        </div>

                                    </div>
                                    <br><br><br>                                                                                                                                                             
                                </div>
                            </div>   
  
                        </div> 
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Pacientes',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];
            return date;

        },
        formatDateTime: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            return date + " " + time;
        },        
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },    
    data () {
        var self                    = this;
        return {
            "prontuario":           ["dados", "avaliacoes", "evolucoes", "exames", "ged"],
            "loaded":               false,
            "selecionarTodosExamesAtivo": false,
            "selecionarTodosDocumentosAtivo": false,
            "tab":                  "informacoes",
            "data":                 {
                "detalhes":         null,
                "avaliacoes":       null,
                "exames":           null,
                "prescricao":       null,
                "documentos":       null,
                "evolucoes":        null,
                "medicamentos":     null
            },
            "config": {
                "prontuario":       false
            },
            "loading": {
                "submit":           false
            },           
            "form": {
                "evolucoes":        {
                    "_cod":             self.$root.user.cod,
                    "_token":           self.$root.user.token,
                    "texto":        ""
                },
                "exames":           {
                    "_cod":             self.$root.user.cod,
                    "_token":           self.$root.user.token,
                    "dataInicio":       "",
                    "dataFinal":        "",
                    "grupo":            "",
                },
                "documentos":           {
                    "_cod":             self.$root.user.cod,
                    "_token":           self.$root.user.token,
                    "dataInicio":       "",
                    "dataFinal":        "",
                    "area":             "",
                }                
            },
        }
    },
    watch: {
                  
    },
    methods: {   
        exportarDocumentos: function() {
            var self        = this;
            console.log("exportarDocumentos()");

            return new Promise(function(resolve, reject) {

                var itens           = [];
                var count           = 0;
                var limite          = 100;
                self.data.documentos.itens.forEach(function(item) {
                    if (count < limite) {
                        if (item.selecionado) {
                            count++;
                            itens.push(item.id);

                            self.$root.addLog({
                                "acao":             "EXPORTAR_GED_PACIENTE", 
                                "pessoaFisicaNome": self.data.detalhes.PESSOA_FISICA.NM_PESSOA_FISICA,
                                "pessoaFisicaCod":  self.$route.query.CD_PESSOA_FISICA,
                                "descricao":        item.listaIndice[4].valor + " - " + item.endereco,
                                "referenciaCod":    item.id
                            });                          
                        }
                    }
                });

                if (count == limite) {
                    alert("Atenção, o limite para exportação é de " + limite + " documentos.");
                }

                if (itens.length == 0) {
                    reject("Nenhum documento selecionado");
                    return false;
                }

                if (itens.length >= 10) {
                    alert("Por favor, aguarde enquanto os documentos estão sendo processados, pode demorar alguns segundos.")
                }

                console.log("Itens selecionados:", itens);

                loading.show();

                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "acao":         "exportar-multiplos",
                    "id":           itens,
                };
                    
                axios.put("api/ged.php", form, {"timeout": 300000})
                .then(response => {

                    console.log("exportarDocumentos()", "success", response.data)
                    loading.hide();
                    if (response.data.link) {
                        window.open(response.data.link, "_system");
                    }
                    resolve(response);
                    // alert(response.data.message);

                })
                .catch(error => {

                    reject(error);
                    console.log("exportarDocumentos()", "error", error.data)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

                });
               
               
            });   
        },       
        selecionarTodosDocumentos: function() {
            var self    = this;
            
            self.selecionarTodosDocumentosAtivo = (self.selecionarTodosDocumentosAtivo ? false : true);
            console.log("selecionarTodosDocumentos()");
            self.data.documentos.itens.forEach(function(item) {
                console.log(">", item);
                item.selecionado = self.selecionarTodosDocumentosAtivo;
            });
            self.$forceUpdate();
        },
        selecionarTodosExames: function() {
            var self    = this;
            
            self.selecionarTodosExamesAtivo = (self.selecionarTodosExamesAtivo ? false : true);
            console.log("selecionarTodosExames()");
            self.data.prescricao.CLINIC_EXAMES_PEDIDO.forEach(function(item) {
                console.log(">", item);
                item.selecionado = self.selecionarTodosExamesAtivo;
            });
            self.$forceUpdate();
        },
        getPreviewPrescricao: function(item) {
            var self = this;
            console.log("getPreviewPrescricao()", item);
            return new Promise(function(resolve, reject) {

                $(".loading-preview-prescricao").show();
                $(".preview-prescricao").hide();
                
                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "NR_PRESCRICAO": item.NR_PRESCRICAO,
                        "GRUPO":        item.GRUPO,
                        "tipo":         "preview"
                    }
                };

                axios.get("api/exames.php", form)
                .then(response => {
                    
                    console.log("getPreviewPrescricao() response", response);

                    if (response.data.link) {
                        var urlPdf = self.$root.config.url + '/viewer/web/viewer-geral.php?_cod=' + self.$root.user.cod + '&_token=' + self.$root.user.token + '&doc=' + response.data.link;

                        $(".preview-prescricao").attr("src", urlPdf);
                        
                        setTimeout(function() {
                            $(".loading-preview-prescricao").hide();
                            $(".preview-prescricao").show();
                        }, 1000);
                        console.log("Setou link", response.data.link)
                    } else {
                        $(".loading-preview-prescricao").hide();    
                    }

                    resolve(response.data);
                  
                })
                .catch(error => {
                    console.log("getPreviewPrescricao() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        },
        openPrescricao: function(item) {
            var self = this;
            console.log("openPrescricao()", item);
            return new Promise(function(resolve, reject) {

                self.data.exames.CLINIC_PEDIDO_EXAME.forEach(function(item, index) {
                    if (item.selecionado) self.data.exames.CLINIC_PEDIDO_EXAME[index]["selecionado"] = false;
                });

                self.selecionarTodosExamesAtivo     = false;
                item.selecionado                    = true;
                self.$forceUpdate();

                self.getPreviewPrescricao(item);

                loading.show();
                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "NR_PRESCRICAO": item.NR_PRESCRICAO,
                        "GRUPO":        item.GRUPO,
                    }
                };

                axios.get("api/exames.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data.prescricao = response.data.result;

                    resolve(response.data.result);
                    if (response.data.result.CLINIC_EXAMES_PEDIDO.length > 0) {

                        $(".dashboard-content-inner")[0].scrollTo({
                            top:            0
                        });                        
                        setTimeout(function() {
                            $(".dashboard-content-inner")[0].scrollTo({
                                top:            $(".scroll-to")[0].getBoundingClientRect().top - (window.__app.mobile.isMobile ? 70 : 0),
                                behavior:       "instant"
                            });             
                            setTimeout(function() {
                                loading.hide();
                            }, 500);                    
                        }, 100);                    
                    } else {
                        loading.hide();
                        alert("🚫 Nenhum exame encontrado dentro desta requisição.");
                    }
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        },
        openExame: function(item) {
            var self = this;
            console.log("openExame()", item);
                
            if (item.DS_LIBERADO != "Liberado") return false;

            loading.show();

            self.$root.addLog({
                "acao":             "VISUALIZAR_EXAME_PACIENTE", 
                "pessoaFisicaNome": self.data.detalhes.PESSOA_FISICA.NM_PESSOA_FISICA,
                "pessoaFisicaCod":  self.$route.query.CD_PESSOA_FISICA,
                "descricao":        item.GRUPO + " - " + item.NM_EXAME,
                "referenciaCod":    item.NR_SEQ_INTERNO
            });

            var form = {
                "_cod":         self.$root.user.cod, 
                "_token":       self.$root.user.token,
                "acao":         "exportar",
                "NR_SEQ_INTERNO":item.NR_SEQ_INTERNO,
                "NM_EXAME":     item.NM_EXAME,
                "GRUPO":        item.GRUPO,
                "DT_PRESCRICAO":item.DT_PRESCRICAO,
                "DS_RESULTADO": item.DS_RESULTADO,
            };
                
            axios.put("api/exames.php", form)
            .then(response => {

                console.log("openExame()", "success", response.data.link)

                var urlPdf = self.$root.config.url + '/viewer/web/viewer-geral.php?_cod=' + self.$root.user.cod + '&_token=' + self.$root.user.token + '&doc=' + response.data.link;

                if (window.cordova) {
                    window.open(urlPdf, "_blank", "location=yes,hideurlbar=yes,hidenavigationbuttons=yes");
                } else {
                    self.$root.openModal("modalExame", "<iframe src='" + urlPdf + "' style='width: 100%; height: 100%; border: none; margin-bottom: -8px'></iframe>"); 
                }
                
                setTimeout(function() {
                    loading.hide();
                }, 1000);
                // alert(response.data.message);

            })
            .catch(error => {

                console.log("exportarExame()", "error", error.data)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

            });
        },
        exportarExames: function() {
            var self        = this;
            console.log("exportarExames()");

            return new Promise(function(resolve, reject) {

                var itens           = [];
                self.data.prescricao.CLINIC_EXAMES_PEDIDO.forEach(function(item) {
                    if (item.selecionado) {
                        itens.push(item.NR_SEQ_INTERNO);
                    }
                });

                if (itens.length == 0) {
                    reject("Nenhum exame selecionado");
                    return false;
                }

                if (itens.length >= 10) {
                    alert("Por favor, aguarde enquanto os exames estão sendo processados, pode demorar alguns segundos.")
                }

                console.log("Itens selecionados:", itens);


                self.data.prescricao.CLINIC_EXAMES_PEDIDO.forEach(function(item) {
                    if (item.selecionado) {
                        self.$root.addLog({
                            "acao":             "EXPORTAR_EXAME_PACIENTE", 
                            "pessoaFisicaNome": self.data.detalhes.PESSOA_FISICA.NM_PESSOA_FISICA,
                            "pessoaFisicaCod":  self.$route.query.CD_PESSOA_FISICA,
                            "descricao":        item.GRUPO + " - " + item.NM_EXAME,
                            "referenciaCod":    item.NR_SEQ_INTERNO
                        });
                    }
                });

                loading.show();

                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "acao":         "exportar-multiplos",
                    "NR_SEQ_INTERNO":itens,
                };
                    
                axios.put("api/exames.php", form, {"timeout": 300000})
                .then(response => {

                    console.log("exportarExames()", "success", response.data)
                    loading.hide();
                    if (response.data.link) {
                        window.open(response.data.link, "_system");
                    }
                    resolve(response);

                })
                .catch(error => {

                    reject(error);
                    console.log("exportarExames()", "error", error.data)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

                });
               
               
            });   
        }, 
        exportarExame: function(item) {
            var self        = this;
            console.log("exportarExame()", item);
            loading.show();

            self.$root.addLog({
                "acao":             "EXPORTAR_EXAME_PACIENTE", 
                "pessoaFisicaNome": self.data.detalhes.PESSOA_FISICA.NM_PESSOA_FISICA,
                "pessoaFisicaCod":  self.$route.query.CD_PESSOA_FISICA,
                "descricao":        item.GRUPO + " - " + item.NM_EXAME,
                "referenciaCod":    item.NR_SEQ_INTERNO
            });

            return new Promise(function(resolve, reject) {

                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "acao":         "exportar",
                    "NR_SEQ_INTERNO":item.NR_SEQ_INTERNO,
                    "NM_EXAME":     item.NM_EXAME,
                    "GRUPO":        item.GRUPO,
                    "DT_PRESCRICAO":item.DT_PRESCRICAO,
                    "DS_RESULTADO": item.DS_RESULTADO,
                };
                    
                axios.put("api/exames.php", form)
                .then(response => {

                    console.log("exportarExame()", "success", response.data.link)
                    loading.hide();
                    window.open(response.data.link, "_system");
                    // alert(response.data.message);

                })
                .catch(error => {

                    console.log("exportarExame()", "error", error.data)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

                });
               
               
            });   
        },   
        visualizarPacs: function(item) {
            var self        = this;
            console.log("visualizarPacs()", item);

            self.$root.addLog({
                "acao":             "VISUALIZAR_PACS_PACIENTE", 
                "pessoaFisicaNome": self.data.detalhes.PESSOA_FISICA.NM_PESSOA_FISICA,
                "pessoaFisicaCod":  self.$route.query.CD_PESSOA_FISICA,
                "descricao":        item.GRUPO + " - " + item.NM_EXAME,
                "referenciaCod":    item.NR_SEQ_INTERNO
            });

            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "acao":         "visualizar-pacs",
                    "NR_PRESCRICAO":item.NR_PRESCRICAO
                };
                    
                axios.put("api/exames.php", form)
                .then(response => {

                    console.log("visualizarPacs()", "success", response.data.link)
                    loading.hide();
                    window.open(response.data.link, "_system");
                    // alert(response.data.message);

                })
                .catch(error => {

                    console.log("visualizarPacs()", "error", error.data)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

                });
               
               
            });   
        },                
        solicitarUsoDados: function() {
            var self        = this;
            console.log("solicitarUsoDados()");

            loading.show();

            self.$root.addLog({
                "acao":             "SOLICITAR_PERMISSAO_PACIENTE", 
                "pessoaFisicaNome": self.data.detalhes.PESSOA_FISICA.NM_PESSOA_FISICA,
                "pessoaFisicaCod":  self.$route.query.CD_PESSOA_FISICA
            });       

            var form = {
                "_cod":                 self.$root.user.cod, 
                "_token":               self.$root.user.token,
                "acao":                 "solicitar",
                "CD_PESSOA_FISICA":     self.$route.query.CD_PESSOA_FISICA
            };
                
            axios.put("api/uso-de-dados.php", form)
            .then(response => {

                console.log("solicitarUsoDados()", "success", response.data)
                loading.hide();
                alert(response.data.message);

            })
            .catch(error => {

                console.log("solicitarUsoDados()", "error", error.data)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

            });

        },
        updateSintomas: function() {
            var self        = this;
            console.log("updateSintomas()", self.data.detalhes.usuario.enviarSintomas);

            loading.show();

            var form = {
                "_cod":         self.$root.user.cod, 
                "_token":       self.$root.user.token,
                "acao":         "sintomas",
                "usuarioCod":   self.data.detalhes.usuario.cod,
                "enviarSintomas": self.data.detalhes.usuario.enviarSintomas
            };
                
            axios.put("api/pacientes.php", form)
            .then(response => {

                console.log("updateSintomas()", "success", response.data)
                loading.hide();
                alert(response.data.message);

            })
            .catch(error => {

                console.log("updateSintomas()", "error", error.data)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

            });

        },
        changeSintomas: function(e) {
            var self        = this;
            console.log("changeSintomas()", e.srcElement);
          
            e.stopPropagation();
            e.preventDefault();
            setTimeout(function() {
                var checked = $("#enviar-sintomas").is(":checked");
                console.log("checked?", $("#enviar-sintomas").is(":checked"))
                
                confirm("Você tem certeza que deseja alterar?", function() {
                    if (checked) {
                        console.log("Setou 0")
                        self.data.detalhes.usuario.enviarSintomas = 0;
                    } else {
                        console.log("Setou 1")
                        self.data.detalhes.usuario.enviarSintomas = 1;
                    }
                    self.$forceUpdate();
                    self.updateSintomas();
                });
            }, 100);
        },
        setTab: function(tab) {
            var self        = this;
            console.log("setTab()", tab);
            self.tab        = tab;


            switch(tab) {
                case "informacoes":
                    self.$root.addLog({
                        "acao": "VISUALIZAR_INFORMACOES_PACIENTE", 
                        "pessoaFisicaNome": self.data.detalhes.PESSOA_FISICA.NM_PESSOA_FISICA,
                        "pessoaFisicaCod": self.$route.query.CD_PESSOA_FISICA
                    });
                    break;

                case "evolucoes":
                    self.$root.addLog({
                        "acao": "VISUALIZAR_EVOLUCOES_PACIENTE", 
                        "pessoaFisicaNome": self.data.detalhes.PESSOA_FISICA.NM_PESSOA_FISICA,
                        "pessoaFisicaCod": self.$route.query.CD_PESSOA_FISICA
                    });
                    break;

                case "avaliacoes":
                    self.$root.addLog({
                        "acao": "VISUALIZAR_AVALIACOES_PACIENTE", 
                        "pessoaFisicaNome": self.data.detalhes.PESSOA_FISICA.NM_PESSOA_FISICA,
                        "pessoaFisicaCod": self.$route.query.CD_PESSOA_FISICA
                    });
                    break;

                case "exames":
                    self.data.prescricao = null;
                    self.$root.addLog({
                        "acao": "VISUALIZAR_EXAMES_PACIENTE", 
                        "pessoaFisicaNome": self.data.detalhes.PESSOA_FISICA.NM_PESSOA_FISICA,
                        "pessoaFisicaCod": self.$route.query.CD_PESSOA_FISICA
                    });
                    break;

                case "documentos":
                    self.$root.addLog({
                        "acao": "VISUALIZAR_GED_PACIENTE", 
                        "pessoaFisicaNome": self.data.detalhes.PESSOA_FISICA.NM_PESSOA_FISICA,
                        "pessoaFisicaCod": self.$route.query.CD_PESSOA_FISICA
                    });
                    break;


                default:

                    break;
            }

            if (tab == "informacoes") {
                self.get(true);
            } else {
                self.getTab(tab);
            }
        },                   
        get: function(load) {
            var self        = this;
            console.log("get()");
            if (load) loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "CD_PESSOA_FISICA": self.$route.query.CD_PESSOA_FISICA
                    }
                };

                axios.get("api/pacientes.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data.detalhes = response.data.result;


                    if (!self.data.detalhes.permissao) {
                        self.$root.addLog({
                            "acao":             "VISUALIZAR_SEM_PERMISSAO_PACIENTE", 
                            "pessoaFisicaNome": self.data.detalhes.PESSOA_FISICA.NM_PESSOA_FISICA,
                            "pessoaFisicaCod":  self.$route.query.CD_PESSOA_FISICA
                        });
                    } else {
                        self.$root.addLog({
                            "acao":             "VISUALIZAR_PACIENTE", 
                            "pessoaFisicaNome": self.data.detalhes.PESSOA_FISICA.NM_PESSOA_FISICA,
                            "pessoaFisicaCod":  self.$route.query.CD_PESSOA_FISICA
                        });                        
                    }

                    if (load) loading.hide();


                    if (self.config.prontuario && !self.config.loaded) {
                        self.config.loaded = true;
                        setTimeout(function() {
                            var porcentagem = 0;
                            var i           = 0;
                            self.prontuario.forEach(function(item) {
                                if (self.config.prontuario[item]) {
                                    i++;
                                }
                            });
                            // porcentagem     = (100 / i) - (window.__app.mobile.isMobile ? 0.27 : 0.158);
                            // $(".menu-prontuario").width(porcentagem + "%")
                        }, 100);
                    }

                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    if (load) loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        },
        getTab: function(tab) {
            var self        = this;
            console.log("getTab()", tab);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "CD_PESSOA_FISICA": self.$route.query.CD_PESSOA_FISICA,
                        "NR_PRONTUARIO": self.data.detalhes.PESSOA_FISICA ? self.data.detalhes.PESSOA_FISICA.NR_PRONTUARIO : null,
                        "tipo":         tab
                    }
                };

                if (tab == "exames") {
                    form.params.dataInicio = self.form.exames.dataInicio;   
                    form.params.dataFinal  = self.form.exames.dataFinal;   
                    form.params.grupo      = self.form.exames.grupo;   
                }

                if (tab == "documentos") {
                    form.params.dataInicio  = self.form.documentos.dataInicio;   
                    form.params.dataFinal   = self.form.documentos.dataFinal;   
                    form.params.area        = self.form.documentos.area;   
                }


                axios.get("api/pacientes.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    if (tab == "exames") {
                        if (self.data.exames) {
                            if (self.data.exames.grupos.length > 0 && response.data.result.grupos.length == 0) {
                                response.data.result.grupos = JSON.parse(JSON.stringify(self.data.exames.grupos));
                                console.log("Setou grupos manualmente", response.data.result.grupos) 
                            }   
                        }
                    }
                    if (tab == "documentos") {
                        if (!response.data.result.areas) {
                            response.data.result.areas = [];
                        }   
                    }
                    self.data[tab] = response.data.result;


                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    reject(error);
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        },       
        getConfig: function(force) {
            var self        = this;
            console.log("getConfig()");
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "nome":         "prontuario"
                    }
                };

                axios.get("api/itens.php", form)
                .then(response => {
                    
                    console.log("getConfig() response", response);

                    self.config["prontuario"] = response.data.result.objeto; 
                    setTimeout(function() {
                        self.$forceUpdate();
                    }, 100);

                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getConfig() error", error);
                    reject(error);
                    
                });   
            });   
        },             
        openPDF: function(url, item) {
            console.log("openPDF", url)
            var self = this;
            // return false;
            window.open(url, "_blank", "location=yes,hideurlbar=yes,hidenavigationbuttons=yes");

            self.$root.addLog({
                "acao":             "VISUALIZAR_GED_PACIENTE", 
                "pessoaFisicaNome": self.data.detalhes.PESSOA_FISICA.NM_PESSOA_FISICA,
                "pessoaFisicaCod":  self.$route.query.CD_PESSOA_FISICA,
                "descricao":        item.listaIndice[4].valor + " - " + item.endereco,
                "referenciaCod":    item.id
            });

        },
        exportarPDF: function(url, item) {
            console.log("exportarPDF", url);
            var self = this;
            window.open(url, "_system");

            self.$root.addLog({
                "acao":             "EXPORTAR_GED_PACIENTE", 
                "pessoaFisicaNome": self.data.detalhes.PESSOA_FISICA.NM_PESSOA_FISICA,
                "pessoaFisicaCod":  self.$route.query.CD_PESSOA_FISICA,
                "descricao":        item.listaIndice[4].valor + " - " + item.endereco,
                "referenciaCod":    item.id
            });           
        },        
        submit: function(tab) {
            var self            = this;
            console.log("submit", tab, self.form[tab]);
            loading.show();

            self.form[tab].CD_PESSOA_FISICA = self.$route.query.CD_PESSOA_FISICA;
            
            axios.post("api/" + tab + ".php", self.form[tab])
            .then(response => {

                console.log("submit()", tab, "success", response.data)
                loading.hide();
                self.form.evolucoes.texto = "";
                self.getTab(tab);

            })
            .catch(error => {

                console.log("submit()", tab, "error", error.data)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

            });

        },

    },
    created: function() {


    },
    mounted: function() {
        var self = this;
        if (!self.$route.query.CD_PESSOA_FISICA) {
            self.$root.back();
            return false;
        }

        loading.show();

        Promise.all([
            self.get(),
            self.getConfig(),
        ]).then(function() {
        
            self.$forceUpdate();
            loading.hide();
            
        }).catch(function(error) {
            loading.hide();
        });         
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .submit-field h5 {
        font-weight: 400 !important;
    }

    .table td button i {
        font-size: 20px !important;
        color: #fff;
    }
    .table td button {
        margin-top: 0px !important;
    }
    .table td {
        /*border-right: none;*/
        /*border-left: none;*/
    }
    .table td input, .table td select {
        margin-top: 0px;
        margin-bottom: 0px;
        text-align: left
    }
    .read-only {
        pointer-events: none !important;
        -webkit-touch-callout: none;                /* prevent callout to copy image, etc when tap to hold */
        -webkit-text-size-adjust: none;             /* prevent webkit from resizing text to fit */
        -webkit-user-select: none;             
    }
    .attachment-box {
        border: none !important;
    }
    div.float-right {
        float: right;
        display: inline-block;
    }
    .buttons {
        position: absolute;
        bottom: 10px;
        right: 10px;        
    }
    .attachment-box small div {
        font-size: 12px;
    }
    .attachment-box small {
        color: #888;
        display: block;
    }
    .attachment-box span {
        font-size: 16px !important;
        margin-bottom: 5px;
    }
    .td-50 {
        width: 50%;
        display: inline-block;
    }
    .td-50-l {
        border-right: 0px !important;
    }
    small.dark {
        color: #555;
    }
    small.dark i {
        color: var(--theme-color-primary);
    }
    .dashboard-status-button.color-secondary {
        top: 8px;
    }
    .menu-dropdown {
        margin-top: 0px;
        right: 3px;
        position: absolute !important;
    }
    .menu-dropdown .button {
        padding-top: 0px !important;
        padding-bottom: 0px !important;
    }
    .menu-dropdown ul li a:after {
        display: none !important;
    }

    .menu-dropdown ul li ul {
        right: 0px;
        left: auto !important;
        top: 85px;
    }
    .menu-dropdown ul ul:after {
        left: auto !important;
        right: 25px;
        border-bottom: 5px solid var(--theme-color-primary) !important;
    }
    .menu-dropdown .dropdown-nav {
        background: var(--theme-color-primary) !important;
    }
    .menu-dropdown .dropdown-nav li a{
        color: #fff !important;
    }

    .exportar-pdf {
        padding-top: 0px;
        padding-bottom: 0px !important;
        line-height: 12px;
        position: relative;
        left: -32px;
        font-size: 12px;
        height: 20px;
    }        

    .exames p {
        font-size: 14px !important;
    }

    .sem-permissao {
        pointer-events: none !important;
        opacity: 0.5 !important;
        -webkit-filter: blur(8px);    
        backdrop-filter: blur(3px);
        filter: blur(8px);        
        -webkit-user-select: none !important; /* Safari */
        -ms-user-select: none !important; /* IE 10 and IE 11 */
        user-select: none !important; /* Standard syntax */
    }

    .solicitar-permissao h3 i {
        top: 4px;
    }

    .solicitar-permissao h3, .solicitar-permissao h4 {
        color: #111;
        text-align: center;
        margin-bottom: 15px;
        line-height: 110%;
    }

    .solicitar-permissao h4 {
        font-weight: 300;
    }

    .solicitar-permissao small {
        line-height: 120%;
        display: block;
        font-weight: 300;
        margin-top: 10px;
    }

    .solicitar-permissao {
        padding-left: 25px;
        padding-right: 25px;
        position: fixed;
        left: 0px;
        right: 0px;
        height: 100%;
        margin-top: -20px;
        /*background: #000;*/
        z-index: 99999;
        color: #444;
        text-align: center !important;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .tabs-default .tabs-header a {
        display: flex;
        flex-direction: column;
        /* align-items: center; */
        align-content: center;
        /* flex-wrap: nowrap; */
        height: 100%;
        justify-content: center;        
    }

    .tabs-default {
        margin-left: 0px;
        margin-right: 0px;
    }

    .dashboard-box-list li.disabled {
        opacity: 0.8 !important;
    }
    .dashboard-box-list li.disabled .job-listing {
        background: #efefef !important;
    }

    .lg-scroll {
        height: 100vh; 
        border: 1px solid #ddd; 
        overflow-y: scroll; 
        border-radius: 6px;        
    }

    .loading-preview-prescricao {
        width: 100%; 
        height: 100vh;        
        background: #efefef;
        width: 100%;
        height: 100vh;
        background: #efefef;
        text-align: center;
        padding-top: 10%;  
        display: none;      
    }

    @media only screen and (max-width: 500px) { 
        .tabs-default .tabs-header a {
            font-size: 3vw !important;
        }
        
        .lg-scroll {
            height: auto !important;
            border: none !important;
            overflow-y: hidden !important;
            margin-bottom: 20px;
        }

        .tabs-default {
            margin-left: -20px !important;
            margin-right: -20px !important;
        }

        .preview-prescricao {
            width: 100vw !important;
            height: 100vh;
            border: none;
            display: block;
            position: absolute;
            left: -12px;
            right: -12px;            
        }

        .loading-preview-prescricao {
            width: 100vw !important;
            height: 100vh;
            border: none;
            display: block;
            position: absolute;
            left: -12px;
            right: -12px;            
        }        

    }

    input[type="date"]::before {
        content: attr(data-placeholder) !important;
        /* width: 100% !important; */
        /* overflow: hidden; */
        position: absolute;
        background: #fff;
        height: 34px;
        right: 11px;
        left: 20px;
        width: auto !important;
        min-width: 50%;
        white-space: nowrap;
        text-overflow: ellipsis;
        border-radius: 20px; 
    }

    .menu-prontuario {
        flex-shrink: 0;
        flex: 1;
    }
</style>



// WEBPACK FOOTER //
// src/components/Paciente.vue